import Cleave from "cleave.js";

export default {
  name: "cleave",
  bind(el, binding) {
    const input = el.querySelector("input");
    input._vCleave = new Cleave(document.createElement("input"), binding.value);
    input._vCleave.lastValue = input.value;
    input._vCleave.setRawValue(input.value);
    input.value = input._vCleave.getFormattedValue();
  },
  /* update(el, binding) {
    const input = el.querySelector('input')
    input._vCleave.destroy()
    input._vCleave = new Cleave(input, binding.value)
  }, */
  unbind(el) {
    const input = el.querySelector("input");
    input._vCleave.destroy();
  }
};

export const masks = {
  number: {
    delimiters: [],
    blocks: [99],
    numericOnly: true
  },
  currency: {
    prefix: "R$ ",
    numeralDecimalMark: ",",
    delimiter: ".",
    numeral: true
  },
  time: {
    time: true,
    timePattern: ["h", "m"]
  },
  phone: {
    delimiters: ["-"],
    blocks: [4, 4],
    numericOnly: true
  },
  registrationPlate: {
    delimiters: ["-"],
    blocks: [3, 4],
    uppercase: true,
    numericOnly: false
  },
  mercosulPlate: {
    blocks: [7],
    uppercase: true,
    numericOnly: false
  },
  cellphone: {
    delimiters: ["-"],
    blocks: [5, 4],
    numericOnly: true
  },
  longPhone: {
    delimiters: ["(", ") ", "-"],
    blocks: [0, 2, 4, 4],
    numericOnly: true
  },
  longCellphone: {
    numericOnly: true,
    blocks: [0, 2, 5, 4],
    delimiters: ["(", ")", "-"],
  },
  zipcode: {
    delimiters: ["-"],
    blocks: [5, 3],
    numericOnly: true
  },
  CPF: {
    delimiters: [".", ".", "-"],
    blocks: [3, 3, 3, 2],
    numericOnly: true
  },
  CNPJ: {
    delimiters: [".", ".", "/", "-"],
    blocks: [2, 3, 3, 4, 2],
    numericOnly: true
  }
};

// TODO: Remove this alternative to Vue 2.6
export const cleaveRefresh = (
  event,
  { ranges, condition } = { ranges: null, condition: null }
) => {
  const input = event.target;
  const { _vCleave } = input;

  const rawValue = input.value;
  const isBackspace = _vCleave.lastValue.length >= input.value.length;

  if (_vCleave === undefined) return;

  let props = _vCleave.properties;

  // dynamic masks
  if (ranges) {
    let mask;

    Object.keys(ranges).forEach(i => {
      if (rawValue.length >= i) mask = ranges[i];
    });

    props = {
      ...props,
      ...masks[mask]
    };
  } else if (condition) {
    const mask = condition(rawValue);

    props = {
      ...props,
      ...masks[mask]
    };
  }

  input._vCleave.destroy();
  input._vCleave = new Cleave(document.createElement("input"), props);
  input._vCleave.setRawValue(rawValue);
  input.value = input._vCleave.getFormattedValue();

  const oldLastChar = _vCleave.lastValue.substring(
    _vCleave.lastValue.length - 1
  );

  if (isBackspace && isNaN(oldLastChar)) {
    input.value = input.value.substring(0, input.value.length - 1);
  }

  input._vCleave.lastValue = input.value;
};
